<loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

<div class="cs-page-list-grid">
  <!-- Filters Panel -->
  @if (filterConfig() && showFilters()) {
    <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
  }

  <!-- Data Table Panel -->
  <p-panel [header]="'Internal_Returns' | translateWF: 'Internal Returns'">
    <ng-template pTemplate="icons">
      <p-button
        [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
        [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
        (click)="showFilters.set(!showFilters())"
        variant="outlined"
        size="small"
      />
    </ng-template>
    <p-card data-variant="compact">
      <p-table [value]="internalReturnList()" [sortOrder]="1" selectionMode="single" [customSort]="true" (sortFunction)="onTableSort($event)">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 80px">{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
            <th pSortableColumn="number">
              {{ 'IR_Number' | translateWF: 'IR Number' }}
              <p-sortIcon field="number"></p-sortIcon>
            </th>
            <th>{{ 'IR_Return_Date' | translateWF: 'Return Date' }}</th>
            <th>{{ 'Common_Status' | translateWF: 'Status' }}</th>
            <th>{{ 'Common_Location' | translateWF: 'Location' }}</th>
            <th>{{ 'IR_Dispatch_Number' | translateWF: 'Dispatch Number' }}</th>
            <th>{{ 'IR_Created_By' | translateWF: 'Created By' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-ir>
          <tr class="cursor-pointer">
            <td>
              <p-button
                icon="pi pi-eye"
                [rounded]="true"
                [text]="true"
                severity="info"
                (click)="navigateToDetail(ir.initiator.reference)"
                pTooltip="{{ 'Common_View_Details' | translateWF: 'View / Process' }}"
                tooltipPosition="top"
              />
            </td>
            <td>{{ ir.number }}</td>
            <td>{{ ir.returnDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-6' }}</td>
            <td>
              <p-tag [value]="getStatusLabel(ir.status)" [severity]="getStatusSeverity(ir.status)" />
            </td>
            <td>{{ localHelperService.getLocalizedValue(ir.locationName) || ir.locationCode }}</td>
            <td>{{ ir.dispatchNumber || '-' }}</td>
            <td>{{ ir.createdBy }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center">
              {{ 'IR_No_Returns_Found' | translateWF: 'No internal returns found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [first]="(currentPage - 1) * pageSize"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="[15, 25, 50, 100]"
        dropdownAppendTo="body"
        class="mt-4"
      ></p-paginator>
    </p-card>
  </p-panel>
</div>
